<style scoped>
    @import url("../../../styles/smartControl/dispTable.scss");
</style>

<template>
    <div class="box_dispTable">

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <!-- Titulo principal  && liDisp.length>0 -->
        <div class="lineBtns" v-if="!flagLoading">

            <v-chip class="ml-2" :style="{'width':'180px','justify-content':'center'}">
                <span :style="{'color':'#F39C12'}">{{ t }}</span>
            </v-chip>

        </div>

        <!-- BOX do Painel do dispositivo -->
        <div class="box_liEl mb-4" v-if="!flagLoading && liDisp.length>0">

            <!-- Painel do dispositivo -->
            <div class="painelLiEl mb-2" v-for="(disp,c) in liDisp" :key="c">

                <span class="ml-4">{{ disp.nome }}</span>

                <v-divider class="mb-4" color="#f39c12" :style="{'width':'98%','align-self':'center'}"></v-divider>

                <!-- Painel do parametros do dispositivos -->
                <div v-for="(el,i) in disp.params" :key="i" class="elLi">

                    <span class="el" v-if="el.status == 'on'"><v-icon :style="{'color':'green'}">mdi-circle</v-icon></span>
                    <span class="el" v-else><v-icon :style="{'color':'gray'}">mdi-circle</v-icon></span>
                    <v-divider class="mx-2" color="#f39c12" vertical></v-divider>

                    <span class="el"><v-icon>{{ el.icon }}</v-icon></span>
                    <v-divider class="mx-2" color="#f39c12" vertical></v-divider>

                    <span class="el" :style="{'min-width':'160px'}">{{ el.titulo }}</span>
                    <v-divider class="mx-2" color="#f39c12" vertical></v-divider>

                    <span class="el" :style="{'min-width':'150px'}">
                        <span v-if="el.status == 'on'">marcador:{{ ' ' + el.sub_marcador }}</span>
                    </span>
                    <v-divider class="mx-2" color="#f39c12" vertical></v-divider>

                    <span class="el">
                        <span v-if="el.status == 'on'">unidade:{{ ' ' + el.unidade }}</span>
                    </span>
                
                </div>
            </div>
        </div>

        <div v-if="!flagLoading && liDisp.length==0" class="mb-4">
            <span class="ml-4" :style="{'font-size':'0.8rem'}">Nenhum dispositivo registrado</span>
        </div>

    </div>
</template>

<script>
//import axios from 'axios'

export default {

    //components:{ DialogExec },

    props:['t', 'execSys', 'emailCliente', 'liOrigem'],

    data() {
        return {

            //
            flagLoading:true,

            /*liDisp:[
                {
                    "titulo":"Iluminação artificial",
                    "unidade":"[min]",
                    "icon":"mdi-ceiling-light-outline",
                    "marcador":"luz",
                    "status":"on"
                }
            ],*/
            liDisp:[],
        }
    },

    methods:{

        callInit() {

            this.liDisp = this.liOrigem // from props

            setTimeout(() => {
                //this.liDisp = this.liOrigem
                this.flagLoading = false // -- encerrar loading
                //console.log('DISP TABLE OK')
            },1000)
        },
    },

    created() {
        window.scrollTo(0,0)

        this.sysSelected = this.execSys
        //console.log('[ExecTable] execSys -> sys_selected: ',this.sysSelected)
        //console.log('[ExecTable] emailCliente: ',this.emailCliente)

        this.callInit()
    }
}
</script>